import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";
import { PlayerAvatar } from "../styled-components/PlayerCard.Styles";
import LabelText from "../ui/LabelText";
import LabelNumber from "../styled-components/LabelNumber";
import SecondaryButton from "../ui/SecondaryButton";
import PrimaryButton from "../ui/PrimaryButton";
import { IPlayerCardEventDetails } from "../types/IPlayerCardEventDetails";
import { BASE_URL } from "../config/apiUrls";

const PlayerCardWrapper = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  background: ${({ theme }) => theme.playerContentBackground};
  box-shadow: ${({ theme }) => theme.cardShadow};
`;

const EventPlayerNameContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
`;

const EventPlayerDetailsInfo = styled.div`
  border-top: 1px solid ${({ theme }) => theme.playerDataBorder};
`;

interface EventplayerCardProps {
  playerCardDetails?: IPlayerCardEventDetails | null;
  onClose?: () => void;
  eventType?: string;
}

const EventPlayerCard: React.FC<EventplayerCardProps> = ({ playerCardDetails, onClose, eventType }) => {
  const getEventLabel = (eventType?: string): string => {
    switch (eventType) {
      case "goal":
        return "Goal";
      case "own_goal":
        return "Own goal";
      case "yellow_card":
        return "Yellow Card";
      case "red_card":
        return "Red Card";
      case "shot":
        return "Shot off target";
      case "save":
        return "Save";
      case "penalty_save":
        return "Penalty save";
      case "substitution":
        return "Substituted on";
      default:
        return "";
    }
  };

  return (
    <PlayerCardWrapper className="event-player-card">
      <div className="player-image-info">
        <LabelNumber className="squad-number">{"2"}</LabelNumber>
        <PlayerAvatar className="player-avatar" backgroundImage={playerCardDetails?.playerImageURL || ""} />
        <div className="player-card-club-details">
          <CloseIcon className="close-btn" onClick={onClose} />
          <img src={playerCardDetails?.currentTeamImageURL || ""} alt="ClubImageURL" className="player-club-image" />
        </div>
      </div>
      <div className="event-player-card-details">
        <EventPlayerNameContainer className="event-player-name-container">
          <LabelText className={playerCardDetails?.isEasternPlayer ? "drawer-title" : "player-given-name"}>
            {playerCardDetails?.isEasternPlayer ? playerCardDetails?.familyName : playerCardDetails?.givenName}
          </LabelText>
          <LabelText className={playerCardDetails?.isEasternPlayer ? "player-given-name" : "drawer-title"}>
            {playerCardDetails?.isEasternPlayer ? playerCardDetails?.givenName : playerCardDetails?.familyName}
          </LabelText>
        </EventPlayerNameContainer>
        <div className="goal-details">
          <LabelText className="player-given-name">{getEventLabel(eventType)}</LabelText>
          <LabelText>{(playerCardDetails?.eventMinute! / 60).toFixed(2)}’</LabelText>
        </div>
      </div>
      {eventType !== "yellow_card" && eventType !== "own_goal" && (
        <EventPlayerDetailsInfo className="event-player-details-info">
          {eventType === "goal" && (
            <>
              <EventPlayerNameContainer className="event-details">
                <LabelNumber className="descriptive-large-text">Assist</LabelNumber>
                <LabelNumber className="event-player-card-details">{playerCardDetails?.shotAssistPlayerName}</LabelNumber>
              </EventPlayerNameContainer>
              <EventPlayerNameContainer className="event-details">
                <LabelNumber className="descriptive-large-text">SHot XG</LabelNumber>
                <LabelNumber className="event-player-card-details">{playerCardDetails?.shotXG}</LabelNumber>
              </EventPlayerNameContainer>
            </>
          )}
          {eventType === "shot" && (
            <EventPlayerNameContainer className="event-details">
              <LabelNumber className="descriptive-large-text">Shot XG</LabelNumber>
              <LabelNumber className="event-player-card-details">{playerCardDetails?.shotXG}</LabelNumber>
            </EventPlayerNameContainer>
          )}
          {(eventType === "save" || eventType === "penalty_save") && (
            <EventPlayerNameContainer className="event-details">
              <LabelNumber className="descriptive-large-text">Save From</LabelNumber>
              <LabelNumber className="event-player-card-details">{playerCardDetails?.shotFromPlayerName}</LabelNumber>
            </EventPlayerNameContainer>
          )}
          {eventType === "substituted" && (
            <EventPlayerNameContainer className="event-details">
              <LabelNumber className="descriptive-large-text">Coming Off</LabelNumber>
              <LabelNumber className="event-player-card-details">{playerCardDetails?.substituteOfPlayerName}</LabelNumber>
            </EventPlayerNameContainer>
          )}
        </EventPlayerDetailsInfo>
      )}
      <div className="event-buttons">
        <SecondaryButton
          label="Profile"
          iconType="profile"
          onClick={() => {
            window.open(`${BASE_URL}/player/${playerCardDetails?.playerId!}`, "_blank");
          }}
        />
        <div className="event-secondary-buttons">
          <SecondaryButton iconType="Bookmark" />
          <SecondaryButton iconType="Share" />
        </div>
      </div>
      <PrimaryButton label="Watch Video" iconType="playarrow" />
    </PlayerCardWrapper>
  );
};

export default EventPlayerCard;
